import gql from 'graphql-tag';
import { scheduledSessionParticipantEntryFieldsFragment } from '../fragments';

export const saveScheduledSessionOrderMutation = gql`
  mutation SaveScheduledSessionOrder($scheduledSessionId: ID!, $participantId: ID!, $sessionOrder: [ID!]!) {
    saveScheduledSessionOrder(scheduledSessionId: $scheduledSessionId, participantId: $participantId, sessionOrder: $sessionOrder) {
      ...AdminScheduledSessionParticipantEntryFields
    }
  }

  ${scheduledSessionParticipantEntryFieldsFragment}
`;